$('.purpose-select-js').change(function () {
    let purposeId = parseInt(this.value);
    $('.purposes-list li').removeClass('active');
    $(`.purposes-list li[data-purpose="${purposeId}"]`).addClass('active');
    setPurpose(purposeId);
});

$('.purposes-list li').click(function () {
    let purposeId = parseInt($(this).data('purpose'));
    let currentPurposeId = parseInt($('.purpose-js.active').data('purpose'));
    if(currentPurposeId === purposeId)
        return;

    $('.purposes-list li').removeClass('active');
    $(this).addClass('active');
    $('.purpose-select-js').val(purposeId);
    setPurpose(purposeId);
});

function setPurpose(purposeId) {
    let $old = $('.purpose-js.active');
    let $new = $(`.purpose-js[data-purpose="${purposeId}"]`);

    $old.animate({opacity: 0}, 300);

    setTimeout(() => {
        $old.removeClass('active');
        $new.addClass('active').css({opacity: 0});
        $new.animate({opacity: 1}, 300);
    }, 300);
}